import { render, staticRenderFns } from "./cardNotasEnfermeria.vue?vue&type=template&id=7222bf59&"
import script from "./cardNotasEnfermeria.vue?vue&type=script&lang=js&"
export * from "./cardNotasEnfermeria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports